import Headers from "../../../config/paymentConfig/headers";
import ApiCalls from "../../../config/paymentConfig/apiCalls";
import {
  common,
  RESPONSE,
} from "../../../helpers/paymentHelpers/paymentConstants";
import get from "lodash/get";
import {
  keyMapsAction,
  keyMapsMutation,
} from "../../../helpers/paymentHelpers/storeKeys";
import LocalStorageFunc from "../../../helpers/paymentHelpers/localStorageFunc";
import utility from "../../../helpers/paymentHelpers/utility";

export default {
  namespaced: true,
  state: {
    orderTransactionId: null,
    cashModalToggle: {
      isCashProcessModalOpen: false,
      isCashOtpModalOpen: false,
    },
    maxCount: 45,
    disableResendKey: true,
    codTimeInterval: () => {},
    orderProcessTimer: () => {},
    cashErrorOtpMsg: {
      displayMsg: "",
    },
  },
  getters: {},
  mutations: {
    updateCashErrorOtpMsg(state, payload) {
      state.cashErrorOtpMsg.displayMsg = payload || "";
    },
    updateCashProcessToggle(state, payload) {
      state.cashModalToggle.isCashProcessModalOpen = payload;
      !payload
        ? document.body.classList.remove("body-stop-scroll-mobile")
        : document.body.classList.add("body-stop-scroll-mobile");
    },
    updateCashOtpToggle(state, payload) {
      state.cashModalToggle.isCashOtpModalOpen = payload;
      !payload
        ? document.body.classList.remove("body-stop-scroll-mobile")
        : document.body.classList.add("body-stop-scroll-mobile");
    },
    setOrderTransactionId(state, payload) {
      state.orderTransactionId = payload;
    },
  },
  actions: {
    getCodOtp({ commit, state, dispatch }, payload) {
      try {
        let orderTxnId = {};
        if (payload.orderTransactionId) {
          orderTxnId = payload;
          commit("setOrderTransactionId", payload.orderTransactionId);
        } else {
          orderTxnId.orderTransactionId = state.orderTransactionId
            ? state.orderTransactionId
            : LocalStorageFunc.getOrderTransactionId();
        }
        ApiCalls.GET_COD_OTP({
          headers: Headers(),
          payload: orderTxnId,
        })
          .then(function (res) {
            if (res?.data) {
              switch (res.data.status) {
                case RESPONSE.SUCCESS:
                  // open COD OTP popup
                  utility.wantToDisabledToAllScreenForSubmit(false); // for adding disabled feature while call submit order
                  dispatch("otpTimerWithModal");
                  break;
                case RESPONSE.FAILED:
                  const err = get(res, "errors[0]", "");
                  const errData = {
                    message: err.displayMsg || common.internalServerError,
                    headerText: err.header || common.ops,
                    rightCTAText: err.btnMsg || common.ok,
                  };
                  dispatch(keyMapsAction.OPEN_ERROR_MODAL, errData, {
                    root: true,
                  });
                  break;
                default:
                  const errObj = {
                    message: common.internalServerError,
                    headerText: common.ops,
                    rightCTAText: common.ok,
                  };
                  dispatch(keyMapsAction.OPEN_ERROR_MODAL, errObj, {
                    root: true,
                  });
                  break;
              }
            } else if (res?.errors) {
              const err = get(res, "errors[0]", "");
              const errData = {
                message: err.displayMsg || common.internalServerError,
                headerText: err.header || common.ops,
                rightCTAText: err.btnMsg || common.ok,
              };
              dispatch(keyMapsAction.OPEN_ERROR_MODAL, errData, { root: true });
            } else if (res?.error) {
              const errData = {
                message: res.message || common.internalServerError,
                headerText: common.ops,
                rightCTAText: common.ok,
              };
              dispatch(keyMapsAction.OPEN_ERROR_MODAL, errData, { root: true });
            } else {
              const errObj = {
                message: common.internalServerError,
                headerText: common.ops,
                rightCTAText: common.ok,
              };
              dispatch(keyMapsAction.OPEN_ERROR_MODAL, errObj, { root: true });
            }
          })
          .catch(function (error) {
            console.log("ERROR in GET COD OTP ....101", error);
            const err = get(error, "errors[0]", "");
            const errData = {
              message: err.displayMsg || "Failed to place order",
              headerText: err.header || common.ops,
              rightCTAText: err.btnMsg || common.ok,
            };
            dispatch(keyMapsAction.OPEN_ERROR_MODAL, errData, { root: true });
          });
      } catch (err) {
        console.error("ERROR on get OTP saga", err);
      }
    },
    resendTimerHandlerForCash({ state, dispatch }) {
      dispatch("clearResendTimerInterval"); // reset the interval before start resend timer again
      state.maxCount = 45;
      state.disableResendKey = true;
      if (state.maxCount > 0 && state.maxCount !== 0) {
        state.codTimeInterval = setInterval(() => {
          state.maxCount -= 1;
          if (state.maxCount === 0) {
            state.disableResendKey = false;
            clearInterval(state.codTimeInterval);
          }
        }, 1000);
      }
    },
    clearResendTimerInterval({ state }) {
      clearInterval(state.codTimeInterval);
    },
    otpTimerWithModal({ commit, dispatch }) {
      commit("updateCashOtpToggle", true);
      dispatch("resendTimerHandlerForCash"); // start the timer in case of cash otp modal
    },
    clearOrderProcessTimerCall({ state }) {
      clearTimeout(state.orderProcessTimer); // clear the timeout on cancel order button
    },
    cashOrderSubmitCall({ state, dispatch, commit, rootState }) {
      const { orderProcessTimeInSec = 3 } = get(
        rootState,
        "Global.appConfig.config",
        {}
      );
      let newOrderProcess =
        orderProcessTimeInSec == 0 ? 0 : orderProcessTimeInSec;
      let payload = { paymentMode: "CASH" };
      if (newOrderProcess > 0) {
        dispatch("clearOrderProcessTimerCall"); // reset the order process timer
        state.orderProcessTimer = setTimeout(() => {
          commit(keyMapsMutation.UPDATE_CASH_PROCESS_TOGGLE, false, {
            root: true,
          });
          dispatch(keyMapsAction.INIT_PLACE_ORDER, payload, { root: true });
        }, newOrderProcess * 1000);
        commit(keyMapsMutation.UPDATE_CASH_PROCESS_TOGGLE, true, {
          root: true,
        }); // calling Cash process modal
      } else {
        dispatch(keyMapsAction.INIT_PLACE_ORDER, payload, { root: true });
      }
    },
  },
};
